import { FormQuestionTasksComponent } from './form-question-tasks.component';

export default angular
  .module('sfMobile.component.question-tasks', [])
  .component('sfFormQuestionTasks', FormQuestionTasksComponent).name;
